import React, { useContext } from 'react';
import './queryComponent.css';

import one from '../../assets/images/queryComponent/oneICon.png';
import two from '../../assets/images/queryComponent/twoIcon.png';
import three from '../../assets/images/queryComponent/threeIcon.png';
import headImg from '../../assets/images/queryComponent/headImg.png';
import advisor from '../../assets/images/queryComponent/advisor.png';
// import headImg from './howItWorks.png';
// import one from './one.png';
// import two from './two.png';
// import three from './three.png';
import { Divider } from '@mui/material';
import { MyContext } from '../../context';

function QueryComponent() {
  const { pageData } = useContext(MyContext);

  return (
    <section className="querySection">
      <div id="how-it-works" className="container">
        <div style={{ marginBottom: '20px' }} className="commonHeading">
          <div className="query-header">
            {pageData?.queryPage?.header}
            <img
              loading="lazy"
              className="how-it-works-img"
              src={headImg}
              alt="how it works"
            ></img>
          </div>
        </div>
        <div className="how-it-works-card-wrap">
          {pageData?.queryPage?.cardsData?.map((data, index) => (
            <div className="how-it-works-card">
              <div className="how-it-works-card-head">
                <img
                  loading="lazy"
                  className="query-card-image"
                  alt=""
                  src={data?.img}
                ></img>
                <h5>{data?.headder}</h5>
              </div>
              <Divider
                style={{
                  borderWidth: '2px',
                  marginBottom: '1rem',
                  marginTop: '1rem',
                  borderColor: '#e5e8ee',
                }}
              />
              <div className="how-it-works-card-body">{data?.body}</div>
            </div>
          ))}
        </div>
        <div className="advisor-container">
          <img
            loading="lazy"
            src={advisor}
            style={{ width: '90px', height: '90px' }}
            alt="how it works"
          ></img>
          <div>{pageData?.queryPage?.advisory}</div>
        </div>
      </div>
    </section>
  );
}

export default QueryComponent;
